// extracted by mini-css-extract-plugin
module.exports = {"textWithFade":"TextWithFade_textWithFade__uJVxL","dark":"TextWithFade_dark__3lJ9A","overflowing":"TextWithFade_overflowing__QlNw8"};